<template>
    
    <div class="main">
        <c-panel>
            <form-instituicao-superior :paramId="$route.params.id" v-on:onSubmitInstituicaoSuperior="onSubmitInstituicaoSuperior"></form-instituicao-superior>
        </c-panel>
    </div>
    
</template>
<script>

import formInstituicaoSuperior from "./form"

export default {
    methods:{

        onSubmitInstituicaoSuperior(){

            this.$router.push('/admin/instituicao-superior');  
        }
    },
    components:{ formInstituicaoSuperior }
}
</script>
